import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from 'src/app/@core/components/ui/popover/popover.component';
import { ButtonComponent } from 'src/app/@core/components/ui/button/button.component';
import { IconComponent } from 'src/app/@core/components/ui/icon/icon.component';
import { TextCasePipe } from '../../pipes/textCase.pipe';

export interface SortFieldOption<T extends string = string> {
  label: string;
  value: T;
}

@Component({
  selector: 'app-sort-popover',
  standalone: true,
  imports: [CommonModule, PopoverComponent, ButtonComponent, IconComponent, TextCasePipe],
  templateUrl: './sort-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SortPopoverComponent<T extends string = string> {
  @ViewChild('popover') private _popover!: PopoverComponent;

  /** List of sort field options displayed in the popover. */
  readonly fields = input.required<SortFieldOption<T>[]>();

  /** Currently selected field value — supports two-way binding via [(sortField)]. */
  readonly sortField = model.required<T>();

  /** Currently selected order — supports two-way binding via [(sortOrder)]. */
  readonly sortOrder = model<'asc' | 'desc'>('desc');

  /** Disables the trigger button. */
  readonly disabled = input<boolean>(false);

  /** Emits after the user picks a field or order and the popover closes. */
  readonly sortChange = output<{ field: T; order: 'asc' | 'desc' }>();

  selectField(value: T): void {
    this.sortField.set(value);
    this._emit();
    this._popover.hide();
  }

  selectOrder(order: 'asc' | 'desc'): void {
    this.sortOrder.set(order);
    this._emit();
    this._popover.hide();
  }

  private _emit(): void {
    this.sortChange.emit({ field: this.sortField(), order: this.sortOrder() });
  }
}
